import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { SessionService } from 'app/sessions/session.service';
import { DateService } from 'app/date/date.service';
import { UtilService } from 'app/hrms/shared/util.service';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { UserService } from 'app/users/shared/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-layout',
  templateUrl: './notification-layout.component.html',
  styleUrls: ['./notification-layout.component.scss']
})
export class NotificationLayoutComponent implements OnInit {
  shipmentsNotificationsList:any;
  leavesNotificationsList:any;
  myLeavesNotificationsList:any;
  myAttendanceNotificationsList:any;
  attendanceNotificationsList:any;
  @Output() messageEvent = new EventEmitter<string>();
  viewType:string ="few";
  constructor(private ls:LogisticsService, private ss:SessionService, private dateService:DateService, private util:UtilService, private hrms:HRMSService, private us:UserService, private router:Router) { }

  ngOnInit() {
    if(this.ss.getUserRole == 'admin' || this.ss.getUserRole == 'super admin')
    {
      this.getShipmentNotification();
      this.getLeaveNotification();
      this.getAttendanceNotification();
      this.getMyLeaveNotification();
      this.getMyAttendanceNotification();  
    }
    else
    {
      this.getMyLeaveNotification();
      this.getMyAttendanceNotification();
    }
  }
  getShipmentNotification()
  {
    this.ls.getNewlyArrivedShipments().on("value",(data)=>{
      var shipments =  data.val();
      this.shipmentsNotificationsList = [];
      for(let i in shipments)
      {
        if(shipments[i].branch == this.ss.getUserBranch || this.ss.getUserRole == 'super admin')
        {
          var createdAt  = (shipments[i].createdAt).split("/");
          var diff = this.util.diff_hours(new Date(),new Date(createdAt[2],createdAt[1],createdAt[0]));
          var d = {
            message: "New shipment has been arrived with shipment #: "+shipments[i].id,
            id: shipments[i].id,
            time: diff < 24 ? diff+" hours ago": shipments[i].createdAt
          }
          this.shipmentsNotificationsList.push(d);
        }
      }
    });
  }
  
  getLeaveNotification()
  {
    this.hrms.getNewLeaveNotif().on("value",(data)=>{
      var leaves =  data.val();
      this.leavesNotificationsList = [];
      for(let i in leaves)
      {
        this.us.getUser(leaves[i].uid).once("value").then((userData)=>{
          var user = userData.val();
          if(user.branch == this.ss.getUserBranch || this.ss.getUserRole == 'super admin')
          {
            if(leaves[i].status == 'Pending')
            {
              var diff = this.util.diff_hours(new Date(),new Date(leaves[i].requestedOn));
              var d = {
                message: "Leave of "+user.name+"("+leaves[i].requestedOn+")"+" is waiting for your approval.",
                id: i,
                time: diff < 24 ? diff+" hours ago": leaves[i].requestedOn
              }
              this.leavesNotificationsList.push(d);
            }
          }
        });
      }
  });
}
getMyLeaveNotification()
  {
    this.hrms.getMyLeaveNotification(this.ss.getUserId).on("value",(data)=>{
      var leaves =  data.val();
      this.myLeavesNotificationsList = [];
      for(let i in leaves)
      {
          if(leaves[i].notif == 'unread' && leaves[i].status == 'Approved')
          {
            var diff = this.util.diff_hours(new Date(),new Date(leaves[i].requestedOn));
              var d = {
                message: "Your leave has been approved",
                id:i,
                time: diff < 24 ? diff+" hours ago": leaves[i].requestedOn
              }
              this.myLeavesNotificationsList.push(d);
          }
      }
  });
  }
  view(data,from)
  {
    switch(from)
    {
      case "shipment":
      this.hrms.changeNotifStatusToRead(data.id,"shipments").then(()=>{
        this.router.navigate(['/view-shipment-details'], { queryParams : {key: data.i, from: 'shipment'}  });
        this.messageEvent.emit();
      });
      break;
      case "leave":
      this.hrms.changeNotifStatusToRead(data.id,"employeeLeaves").then(()=>{
        this.router.navigate(['/leaves']);
        this.messageEvent.emit();
      });
      break;
      case "attendance":
      this.hrms.updateAttendanceNotif(data.id,"read").then(()=>{
        this.messageEvent.emit();
      });
      break;
    }
  }
  close(data,from)
  {
    switch(from)
    {
      case "shipment":
      this.hrms.changeNotifStatusToRead(data.id,"shipments").then(()=>{
        this.messageEvent.emit();
      });
      break;
      case "leave":
      this.hrms.changeNotifStatusToRead(data.id,"employeeLeaves").then(()=>{
        this.messageEvent.emit();
      });
      break;
      case "attendance":
      this.hrms.updateAttendanceNotif(data.id,"read").then(()=>{
        this.messageEvent.emit();
      });
      break;
    }
}
getMyAttendanceNotification()
{
  this.hrms.getMyAttendanceNotification(this.ss.getEmployeeId).on("value",(data)=>{
  this.myAttendanceNotificationsList = [];    
    var attendanceNotif = data.val();
    for(let i in attendanceNotif)
    {
      //console.log("my attendanceNotif",attendanceNotif[i],i);
      if(attendanceNotif[i].notif == "unread" && attendanceNotif[i].status == "approved")
      {
        var diff = this.util.diff_hours(new Date(),new Date(attendanceNotif[i].date));
        var d = {
          message: "Your attendance has been approved",
          id: i,
          time: diff < 24 ? diff+" hours ago": attendanceNotif[i].date
        }
        this.myAttendanceNotificationsList.push(d);
    }
  }
});
}

getAttendanceNotification()
{
  this.hrms.getAttendanceNotification().on("value",(data)=>{
  this.attendanceNotificationsList = [];    
    var attendanceNotif = data.val();
    for(let i in attendanceNotif)
    {
      //console.log("attendanceNotif",attendanceNotif[i],i);
      
      if(attendanceNotif[i].status == "pending")
      {
        this.us.getEmployeeDetails(Number(attendanceNotif[i].eid)).once("value").then((userData)=>{
          userData.forEach(element => {
            var user = element.val();
            //console.log("user",user);
            if(user.branch == this.ss.getUserBranch || this.ss.getUserRole == 'super admin')
            {
                var diff = this.util.diff_hours(new Date(),new Date(attendanceNotif[i].date));
                var d = {
                  message: "Attednace of "+user.name+" ("+attendanceNotif[i].date+")"+" is waiting for your approval.",
                  id: i,
                  time: diff < 24 ? diff+" hours ago": attendanceNotif[i].date,
                  dateId: attendanceNotif[i].date
                }
                this.attendanceNotificationsList.push(d);
                //console.log("this.attendanceNotificationsList",this.attendanceNotificationsList);
              }
          });
      });
    }
  }
});
}
onClickView(type)
{
  this.viewType = type;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/layouts/admin/notification-layout/notification-layout.component.ts